// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.watchas_adsContainer__W292C {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
.watchas_adsContainer__W292C .watchas_adCard__b5uRc {
  justify-content: space-between;
  column-gap: 24px;
  height: 250px;
  width: 30%;
  border-radius: 20px;
  position: relative;
  cursor: pointer;
}
.watchas_adsContainer__W292C .watchas_adCard__b5uRc img {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  object-fit: cover;
}
.watchas_adsContainer__W292C .watchas_adCard__b5uRc .watchas_adDetails__e94J8 {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  z-index: 10;
  color: white;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 30px;
}
.watchas_adsContainer__W292C .watchas_adCard__b5uRc .watchas_adDetailsOverLay__hFaMF {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 159px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 37.92%);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  z-index: 1;
}

.watchas_overlay__68lF2 {
  width: 100%;
  height: 100%;
  gap: 0px;
  opacity: 0.7;
  background-color: black;
  position: fixed;
  left: 0;
  top: 0;
}

.watchas_adVideo__UCDIb {
  background-color: #eee;
  position: fixed;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 75vh;
  width: 80%;
  z-index: 100;
  border-radius: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/styles/watchas.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,SAAA;AACJ;AACI;EACI,8BAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EAEA,kBAAA;EACA,eAAA;AAAR;AAEQ;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AAAZ;AAGQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EAEA,+BAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EAEA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AAHZ;AAMQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mFAAA;EAEA,+BAAA;EACA,gCAAA;EACA,UAAA;AALZ;;AAYA;EACI,WAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;AATJ;;AAaA;EAEI,sBAAA;EACA,eAAA;EAEA,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,gCAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AAZJ","sourcesContent":[".adsContainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 24px;\n\n    .adCard {\n        justify-content: space-between;\n        column-gap: 24px;\n        height: 250px;\n        width: 30%;\n        border-radius: 20px;\n        // background-color: red;\n        position: relative;\n        cursor: pointer;\n\n        img {\n            height: 100%;\n            width: 100%;\n            border-radius: 20px;\n            object-fit: cover;\n        }\n\n        .adDetails {\n            position: absolute;\n            bottom: 0;\n            width: 100%;\n            height: 100px;\n            // background-color: green;\n            border-bottom-left-radius: 20px;\n            border-bottom-right-radius: 20px;\n            z-index: 10;\n            color: white;\n            //styleName: Labels/Medium;\n            font-family: Poppins;\n            font-size: 16px;\n            font-weight: 600;\n            line-height: 24px;\n            text-align: left;\n            padding: 20px;\n            display: flex;\n            flex-direction: column;\n            gap: 12px;\n            padding-bottom: 30px;\n        }\n\n        .adDetailsOverLay {\n            position: absolute;\n            bottom: 0;\n            width: 100%;\n            height: 159px;\n            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 37.92%);\n\n            border-bottom-left-radius: 20px;\n            border-bottom-right-radius: 20px;\n            z-index: 1;\n        }\n    }\n\n\n}\n\n.overlay {\n    width: 100%;\n    height: 100%;\n    gap: 0px;\n    opacity: 0.7;\n    background-color: black;\n    position: fixed;\n    left: 0;\n    top: 0;\n\n}\n\n.adVideo {\n   \n    background-color: #eee;\n    position: fixed;\n    width: 40%;\n    text-align: center;\n    top: 50%;\n    left: 50%;\n    // padding: 20px;\n    transform: translate(-50%, -50%);\n    height: 75vh;\n    width: 80%;\n    z-index: 100;\n    border-radius: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adsContainer": `watchas_adsContainer__W292C`,
	"adCard": `watchas_adCard__b5uRc`,
	"adDetails": `watchas_adDetails__e94J8`,
	"adDetailsOverLay": `watchas_adDetailsOverLay__hFaMF`,
	"overlay": `watchas_overlay__68lF2`,
	"adVideo": `watchas_adVideo__UCDIb`
};
export default ___CSS_LOADER_EXPORT___;
